// extracted by mini-css-extract-plugin
export default {"register-input":"styles_register-input__rFr9V"};